const AOS = require('AOS');

AOS.init();